import { isTauri } from "@/lib/is-tauri";

export type DesktopAction =
  | "toggle-workspace"
  | "text-chat"
  | "voice-chat"
  | "hands-free-voice";

const ACTION_EVENTS: Record<DesktopAction, string> = {
  "toggle-workspace": "toggle-workspace",
  "text-chat": "summon-input-bar",
  "voice-chat": "voice-toggle",
  "hands-free-voice": "voice-lock-toggle",
};

/**
 * Runs a desktop action from a click by emitting the event its global
 * shortcut emits, so both reach the same listeners. No-op outside Tauri.
 */
export async function emitDesktopAction(action: DesktopAction) {
  if (!isTauri()) return;
  const { emit } = await import("@tauri-apps/api/event");
  await emit(ACTION_EVENTS[action], {});
}
